import ChsAddress from './types/ChsAddress';
import DraftApplication from './types/DraftApplication';

function address(): ChsAddress {
  return {
    id: null,
    houseNumber: '',
    halfNumber: '',
    streetDir: '',
    streetName: '',
    streetType: '',
    unitNumber: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    createdBy: '',
    createdDate: '',
    modifiedBy: '',
    modifiedDate: '',
    unitType: '',
    singleFamilyHome: '',
  };
}

function application(): DraftApplication {
  return {
    groupRefKey: null,
    email: '',
    primaryResIndicator: '',
    numberOfRooms: null,
    howManyRooms: null,
    dwellingTypeCd: '',
    dwellingTypeDescr: '',
    propertyRelaCd: '',
    propertyRelaDescr: '',
    address: address(),
    intermediaries: [],
    hasResidenceAttachment: false,
    hasDifferentAttachmentTypes: false,
  };
}

const initial = {
  address,
  application,
};

export default initial;
